// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.confirmation-modal-backdrop {
    background-color: rgba(0, 0, 0, 0.5);
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 100;
  }
  
  .confirmation-modal-content {
    width: 400px;
    background-color: white;
    border-radius: 5px;
    padding: 20px;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);
    text-align: center;
  }
  
  .modal-title {
    font-size: 24px;
    margin-bottom: 20px;
  }
  
  .modal-message {
    font-size: 18px;
    margin-bottom: 30px;
  }
  
  .modal-buttons {
    display: flex;
    justify-content: center;
  }
  
  .modal-button {
    padding: 10px 20px;
    margin: 0 10px;
    border: none;
    cursor: pointer;
    border-radius: 5px;
    font-weight: bold;
    outline: none;
    transition: background-color 0.3s;
  }
  
  .modal-button-no {
    background-color: red;
    color: white;
  }
  
  .modal-button-yes {
    background-color: green;
    color: white;
  }
  
  .modal-button:hover {
    background-color: var(--psblue);
    color: white;
  }
  `, "",{"version":3,"sources":["webpack://./src/sidebar/confirmationModal.css"],"names":[],"mappings":";AACA;IACI,oCAAoC;IACpC,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;IACb,2CAA2C;IAC3C,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,aAAa;IACb,iCAAiC;EACnC;;EAEA;IACE,qBAAqB;IACrB,YAAY;EACd;;EAEA;IACE,uBAAuB;IACvB,YAAY;EACd;;EAEA;IACE,+BAA+B;IAC/B,YAAY;EACd","sourcesContent":["\n.confirmation-modal-backdrop {\n    background-color: rgba(0, 0, 0, 0.5);\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 100;\n  }\n  \n  .confirmation-modal-content {\n    width: 400px;\n    background-color: white;\n    border-radius: 5px;\n    padding: 20px;\n    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);\n    text-align: center;\n  }\n  \n  .modal-title {\n    font-size: 24px;\n    margin-bottom: 20px;\n  }\n  \n  .modal-message {\n    font-size: 18px;\n    margin-bottom: 30px;\n  }\n  \n  .modal-buttons {\n    display: flex;\n    justify-content: center;\n  }\n  \n  .modal-button {\n    padding: 10px 20px;\n    margin: 0 10px;\n    border: none;\n    cursor: pointer;\n    border-radius: 5px;\n    font-weight: bold;\n    outline: none;\n    transition: background-color 0.3s;\n  }\n  \n  .modal-button-no {\n    background-color: red;\n    color: white;\n  }\n  \n  .modal-button-yes {\n    background-color: green;\n    color: white;\n  }\n  \n  .modal-button:hover {\n    background-color: var(--psblue);\n    color: white;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
